﻿const ctrls = {};

function parseDom (dom) {
  const pageElements = dom.querySelectorAll('[data-controller]');
  if (pageElements.length) {
    Array.prototype.forEach.call(pageElements, (singleElement) => {
      const attr = singleElement.getAttribute('data-controller');

      if (!attr) {
        return false;
      }

      if (ctrls.hasOwnProperty(attr)) {
        if(!ctrls[attr])
          return false;

        const instance = ctrls[attr](singleElement);

        if (instance && 'init' in instance) {
          instance.init();
        }
      }
    });
  }
}

function addController (name, constructor) {
  if (!ctrls.hasOwnProperty(name)) {
    ctrls[name] = constructor;
  }
}

function removeController (name) {
  if (!ctrls.hasOwnProperty(name)) {
    delete ctrls[name];
  }
}

function getXconfigFromController (context) {
  const scriptTag = context.querySelector('script[type="text/x-config"]');
  if (!scriptTag)
    return {};

  const scriptTextContent = scriptTag.innerText.replace(/(\r\n|\n|\r)/gm, "").replace(/(\t)/gm, "").replace(/&quot;/g, "\\&quot;").replace(/,}/g, '}').replace(/, }/g, '}');

  if (scriptTextContent.length > 0) {
    try {
      return JSON.parse(decodeEntities(scriptTextContent))
		} catch {
      return {}
		}
  }
  else
    return {}
}

const decodeEntities = (() => {
  var element = document.createElement('div');

  const decodeHTMLEntities = (str) => {
    if (str && typeof str === 'string') {
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }

    return str;
  }

  return decodeHTMLEntities;
})();

export default {
  add: addController,
  remove: removeController,
  parse: parseDom, 
  getConfig: getXconfigFromController, 
};

document.addEventListener('DOMContentLoaded', (e) => {
  parseDom(e.target);
});

document.addEventListener('newDom', (e) => {
  parseDom(e.target);
});